/**
 * InstructorBottomNav — RETIRED 7 Aug 2026.
 *
 * The canonical mobile primary navigation is now docked inside
 * UniversalApplicationShell via `<FounderCockpit />`. This component
 * used to render a competing `position: fixed` bottom bar on every
 * instructor page which stacked with the cockpit and violated the
 * "one canonical mobile nav" doctrine.
 *
 * It is preserved as a no-op so existing imports across the
 * instructor pages continue to compile without a mass refactor. The
 * doctrine `test_mobile_navigation_docked_doctrine.py` enforces that
 * this component keeps returning `null`.
 */
export default function InstructorBottomNav() {
  return null;
}
